import {tApi}from 'tplus-api';
import {TStore} from 'tplus-poslogin'

export default class GuideApi {
    //获取存货明细信息
    static async getGuides(Key = '', other = false) {
        const storeInfo = TStore.restore()
        const idStore = storeInfo.storeID
        const SearchParams = {
            Key,
            IsOtherStore: other,
            CurrentPage: 1,
            PageSize: 20,
            IdStore: idStore
        }
        return await tApi({
            SearchParams
        }, 'chanjet.AA.DR.newRetailBaseInfo.SearchNavigator', false, false);
    }
}

